var map = {
	"./en/sdg_en_(1).png": "8118",
	"./en/sdg_en_(10).png": "f461",
	"./en/sdg_en_(11).png": "d8a6",
	"./en/sdg_en_(12).png": "1219",
	"./en/sdg_en_(13).png": "8087",
	"./en/sdg_en_(14).png": "caa9",
	"./en/sdg_en_(15).png": "53c8",
	"./en/sdg_en_(16).png": "9a85",
	"./en/sdg_en_(17).png": "6f2e",
	"./en/sdg_en_(2).png": "b147",
	"./en/sdg_en_(3).png": "3764",
	"./en/sdg_en_(4).png": "c179",
	"./en/sdg_en_(5).png": "2ba8",
	"./en/sdg_en_(6).png": "c7d6a",
	"./en/sdg_en_(7).png": "5e3b",
	"./en/sdg_en_(8).png": "1124",
	"./en/sdg_en_(9).png": "06e7",
	"./es/sdg_es_(1).png": "6ef7",
	"./es/sdg_es_(10).png": "aaf0",
	"./es/sdg_es_(11).png": "628f",
	"./es/sdg_es_(12).png": "9ec6",
	"./es/sdg_es_(13).png": "9da4",
	"./es/sdg_es_(14).png": "a372",
	"./es/sdg_es_(15).png": "e374",
	"./es/sdg_es_(16).png": "ea27",
	"./es/sdg_es_(17).png": "396b",
	"./es/sdg_es_(2).png": "c8c8",
	"./es/sdg_es_(3).png": "5fd4",
	"./es/sdg_es_(4).png": "77fc",
	"./es/sdg_es_(5).png": "c7b3",
	"./es/sdg_es_(6).png": "dab8",
	"./es/sdg_es_(7).png": "5b12",
	"./es/sdg_es_(8).png": "503e",
	"./es/sdg_es_(9).png": "3c80",
	"./pt-pt/sdg_pt-pt_(1).png": "8257",
	"./pt-pt/sdg_pt-pt_(10).png": "9524",
	"./pt-pt/sdg_pt-pt_(11).png": "c502",
	"./pt-pt/sdg_pt-pt_(12).png": "3f88",
	"./pt-pt/sdg_pt-pt_(13).png": "4acd",
	"./pt-pt/sdg_pt-pt_(14).png": "1a07",
	"./pt-pt/sdg_pt-pt_(15).png": "15db",
	"./pt-pt/sdg_pt-pt_(16).png": "5977",
	"./pt-pt/sdg_pt-pt_(17).png": "d584",
	"./pt-pt/sdg_pt-pt_(2).png": "e331",
	"./pt-pt/sdg_pt-pt_(3).png": "ea92",
	"./pt-pt/sdg_pt-pt_(4).png": "f4c2",
	"./pt-pt/sdg_pt-pt_(5).png": "a64a",
	"./pt-pt/sdg_pt-pt_(6).png": "ef07",
	"./pt-pt/sdg_pt-pt_(7).png": "592f",
	"./pt-pt/sdg_pt-pt_(8).png": "0ad9",
	"./pt-pt/sdg_pt-pt_(9).png": "fc22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7155";